/**
 * Check if WebGL is supported in the browser
 * @returns {boolean} true if WebGL is supported
 */
export function isWebGLSupported() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return !!gl;
  } catch (e) {
    return false;
  }
}

/**
 * Get WebGL support details and error information
 * @returns {Object} details about WebGL support
 */
export function getWebGLInfo() {
  const info = {
    supported: false,
    version: null,
    renderer: null,
    vendor: null,
    error: null
  };

  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    
    if (gl) {
      info.supported = true;
      info.version = gl.getParameter(gl.VERSION);
      
      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        info.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        info.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
      }
    } else {
      info.error = 'WebGL context not available';
    }
  } catch (e) {
    info.error = e.message;
  }

  return info;
}
